import { cn } from 'lib/helpers/utility';

import Icon from '../Icon/Icon';

import { getClasses, getIconSize, getTextClasses } from './lib/getClasses';

/**
 * @param {import('./lib/propTypes').BadgeProps} props
 */

const Badge = (props) => {
  const {
    text,
    size = 'medium',
    color = 'neutral',
    iconColor = color,
    variant = 'lighter',
    isRounded = true,
    icon,
    iconRight,
    className,
    ...rest
  } = props;

  return (
    <div className={cn(getClasses({ text, size, color, variant, isRounded }), className)} {...rest}>
      {icon && (
        <Icon
          icon={icon}
          size={getIconSize(size)}
          color={variant === 'filled' ? 'white' : iconColor}
        />
      )}
      {typeof text === 'object'
        ? text
        : text && <span className={getTextClasses(size, variant)}>{text}</span>}
      {iconRight && (
        <Icon
          icon={iconRight}
          size={getIconSize(size)}
          color={variant === 'filled' ? 'white' : iconColor}
        />
      )}
    </div>
  );
};

export default Badge;
